<ion-row class="table-header">
  <ng-container *ngFor="let col of dataColumns">
    <ion-col
      *ngIf="(isSelectable || col.dataCyName !== 'checkbox') && +col.size !== 0"
      [size]="col.size"
      [attr.data-cy]="col.dataCyName + '-column-heading'"
      [class.checkbox]="col.isCheckbox"
      [class.customer-column]="col.dataCyName === 'customer'"
      [class.is-selected]="sortField === col.sortField"
      [class.white-space-wrap]="col.whiteSpaceWrap"
      [class.non-clickable]="col.isNotSortable"
      (click)="
        !col.isNotSortable && onClick(col.sortField, col.sortDirectionByDefault)
      "
    >
      <p>
        {{ col.label }}
      </p>
      <app-caret-icon
        *ngIf="!col.isNotSortable && !col.isCheckbox"
        [sortField]="sortField"
        [fieldName]="col.sortField"
        [sortDirection]="sortDirection"
      ></app-caret-icon>
    </ion-col>
  </ng-container>
</ion-row>
